import { Link } from "react-router-dom";
import { latestArticles } from "@/mocks/articles";

export default function ArticleGrid() {
  const displayArticles = latestArticles.slice(0, 9);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
              最新<span className="text-primary-500">吃瓜</span>爆料
            </h2>
            <p className="text-foreground-500 text-sm">
              每日更新，不错过任何一个大瓜
            </p>
          </div>
          <Link
            to="/category/daily-gossip"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article, idx) => {
            const isFeature = idx === 0;
            return (
              <article
                key={article.id}
                className={`group rounded-lg overflow-hidden transition-colors ${
                  isFeature
                    ? "lg:col-span-2 lg:row-span-2 bg-foreground-950"
                    : "bg-background-100 hover:bg-background-100/80 border border-background-200/70"
                }`}
              >
                <Link to={`/article/${article.id}`} className="block">
                  <div
                    className={`relative overflow-hidden ${
                      isFeature ? "h-48 md:h-64 lg:h-80" : "h-44"
                    }`}
                  >
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                      loading="lazy"
                    />
                    {isFeature && (
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">
                          重磅爆料
                        </span>
                      </div>
                    )}
                  </div>
                  <div className={`p-4 ${isFeature ? "lg:p-6" : ""}`}>
                    <div
                      className={`flex items-center gap-2 mb-2 ${
                        isFeature ? "text-foreground-400" : "text-foreground-400"
                      } text-xs`}
                    >
                      <span
                        className={`${
                          isFeature
                            ? "text-primary-400"
                            : "text-primary-500"
                        } font-medium`}
                      >
                        {article.categoryName}
                      </span>
                      <span>·</span>
                      <span>{article.date}</span>
                      <span>·</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {(article.views / 10000).toFixed(1)}万
                      </span>
                    </div>
                    <h3
                      className={`font-heading font-bold mb-2 line-clamp-2 transition-colors ${
                        isFeature
                          ? "text-xl md:text-2xl text-white group-hover:text-primary-300"
                          : "text-base text-foreground-950 group-hover:text-primary-500"
                      }`}
                    >
                      {article.title}
                    </h3>
                    <p
                      className={`text-xs leading-relaxed line-clamp-2 ${
                        isFeature
                          ? "text-foreground-400"
                          : "text-foreground-500"
                      }`}
                    >
                      {article.excerpt}
                    </p>
                    {!isFeature && (
                      <div className="flex items-center gap-2 mt-3">
                        {article.tags.map((tag) => (
                          <span
                            key={tag}
                            className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}